import React, { useEffect, useMemo } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actions as CredentialActions } from "../../Ducks/Credentials.duck";
import { FormattedMessage } from "react-intl";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { DivRootStyled } from "./OauthCredentialResponsePage.styles";
const normalizeValue = (value) => (value || "").toString().trim().toLowerCase().replace(/[\s-]+/g, "_");
const resolveStatus = (status, searchParams) => {
  const normalizedStatus = normalizeValue(status);
  const normalizedInvalidType = normalizeValue(searchParams.get("invalidType"));
  const normalizedReason = normalizeValue(searchParams.get("reason"));
  const hasInvalidStateReason = normalizedInvalidType === "invalid_state" || normalizedReason === "invalid_state" || normalizedReason.includes("invalid_state");
  if (hasInvalidStateReason) {
    return "invalid_state";
  }
  return normalizedStatus || status;
};
const OauthCredentialResponsePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { credentialId, status } = useParams();
  const [searchParams] = useSearchParams();
  const resolvedStatus = useMemo(() => resolveStatus(status, searchParams), [status, searchParams]);
  const normalizedResolvedStatus = useMemo(() => normalizeValue(resolvedStatus), [resolvedStatus]);
  const isError = Boolean(normalizedResolvedStatus && normalizedResolvedStatus !== "success");
  useEffect(() => {
    if (credentialId && resolvedStatus) {
      dispatch(CredentialActions.oauthStatus({ [credentialId]: resolvedStatus }));
    }
  }, [dispatch, credentialId, resolvedStatus]);
  if (!resolvedStatus) {
    return null;
  }
  const handleClose = () => {
    navigate("/credential/requests");
  };
  if (isError) {
    return /* @__PURE__ */ React.createElement(Dialog, { open: true, maxWidth: "sm", fullWidth: true }, /* @__PURE__ */ React.createElement(DialogTitle, { sx: { pb: 1 } }, /* @__PURE__ */ React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1 } }, /* @__PURE__ */ React.createElement(ErrorIcon, { color: "error" }), /* @__PURE__ */ React.createElement(Typography, { variant: "h6" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credential.oauth.failedTitle" })))), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(Box, { sx: { py: 2 } }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1", paragraph: true }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credential.oauth.failedMessage" })), /* @__PURE__ */ React.createElement(Typography, { variant: "body2", color: "textSecondary", paragraph: true }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credential.oauth.retryInstruction" })))), /* @__PURE__ */ React.createElement(DialogActions, { sx: { p: 2 } }, /* @__PURE__ */ React.createElement(Button, { onClick: handleClose, variant: "contained", color: "primary" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.proceed" }))));
  }
  return /* @__PURE__ */ React.createElement(DivRootStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: `credential.oauth.${resolvedStatus}` }));
};
export default OauthCredentialResponsePage;
